import {LayoutContext} from 'components/layouts/Default/LayoutContext'
import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import {useHistory} from 'modules/navigation/useRouter'
import React, {useContext,} from 'react'
import {Link, useLocation} from 'react-router-dom'
import {branch, compose} from 'recompose'
import {ContentNotFound} from 'views/AppLocals/ContentNotFound'
import WorkspaceContext from "../../WorkspaceContext";
import {formatNumber} from "../../../../helpers/number";
import {Avatar} from "antd";
import {FaBoxOpen, FaChalkboard} from "react-icons/fa6";
import {useShopForm} from "../../../AppLocals/Shop/functions/useShopForm";
import CRUD from "../../../Shared/enums/CRUD";
import {IoStorefront} from "react-icons/io5";

const StatCard = ({title, value, secondary_value, color, icon, style, href}) => (
    <Link to={href}
          style={style}
          className="px-4 py-3 flex items-center justify-between border border-color-100 background shadow-md rounded-xl no-underline cursor-pointer">
        <div className="flex flex-col flex-1">
            <p className="font-medium text-sm text-color-300 tracking-wider">{title}</p>
            <div className="mt-1 flex items-baseline gap-1">
                <p className="text-2xl font-bold text-gray-900 tracking-wide">{value}</p>
                {
                    !!secondary_value &&
                    <p className="text-base font-medium text-color-500 tracking-wide">{` / ${secondary_value}`}</p>
                }
            </div>
        </div>
        <Avatar
            size={40}
            className={`flex flex-center bg-${color}-100`}
            icon={icon}
        />
    </Link>
);


const ShopDashboard = ({
                           owner_id,
                           owner_type,
                           filter_actions = {
                               sortBy: 'sort-by',
                               keyword: 'keyword',
                           },
                       }) => {
    const t = useTranslate()

    const history = useHistory()

    const location = useLocation()

    const {isSm} = useContext(LayoutContext)
    const {organization} = useContext(WorkspaceContext);

    const {
        modal: shopModal,
        handleAction: handleShopAction,
        onCancel: onShopCancel,
    } = useShopForm({organization})

    return (
        <div className="flex flex-col flex-1 gap-y-3">
            <div className="flex flex-col gap-6">
                <h1 className="text-xl font-bold text-primary uppercase flex items-center">
                    {t("overview")}
                </h1>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                    <StatCard
                        title={t('total shops')}
                        value={formatNumber(organization?.workspace_settings?.shops?.statistics?.shop_count)}
                        color="indigo" icon={<IoStorefront size={20} className="text-secondary"/>}
                        style={{
                            border: '1px solid var(--color-secondary-300)',
                            boxShadow: '0 2px 4px 0px var(--color-secondary-200)',
                        }}
                        href={`/workspace/shop?rel=shops`}
                    />
                    <StatCard
                        title={t('total products')}
                        value={formatNumber(organization?.workspace_settings?.shops?.statistics?.product_count)}
                        color="orange" icon={<FaBoxOpen size={20} className="text-orange-500"/>}
                        style={{
                            border: '1px solid rgba(253, 186, 116, 1)',
                            boxShadow: '0 2px 4px 0px rgba(254, 215, 170, 1)',
                        }}
                        href={`/workspace/shop?rel=shops`}
                    />

                </div>

                <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div
                        style={{
                            boxShadow: '0 -2px 6px -2px rgba(0, 0, 0, 0.08), 0 8px 12px -4px rgba(0, 0, 0, 0.1)',
                            borderRight: '1px solid var(--border-color-50)',
                        }}
                        className="p-6 flex flex-col background rounded-xl shadow-lg border-l-4 border-indigo-500">
                        <h3 className="mb-3 flex items-center text-xl font-bold text-gray-800 tracking-wide">
                            <FaChalkboard size={20} className="mr-2 text-indigo-500"/>
                            {t('initialize shop')}
                        </h3>
                        <p className="flex-1 mb-4 text-color-300 tracking-wider">
                            {t("start setting up your new training content")}
                        </p>
                        <button
                            onClick={() => {
                                handleShopAction(CRUD.CREATE)
                            }}
                            className="w-full px-6 py-2 bg-indigo-500 text-white rounded-lg shadow-md hover:bg-indigo-700 transition font-medium">
                            + {t("create shop")}
                        </button>
                    </div>

                </div>
            </div>
            {shopModal}
        </div>
    )
}


export default compose(
    branch(
        ({owner_id, owner_type}) => _.some([owner_id, owner_type], _.isEmpty),
        () => () => <ContentNotFound/>
    )
)(ShopDashboard)
